import { useState } from "react";
import { useApolloClient, useQuery } from "@apollo/client";
import { FETCH_MATCH_SUMMARIES } from "api/graphql/matchSummaryQuery.js";
import { replacePlusFromURLPath, getApiRole } from "lib/general-helper";
import { roleMapping, queueTypeMapping } from "api/apiHelpers.js";
import { INTERNAL_CURRENT_SEASON } from "@ugg/shared/constants/seasons";

export function getParamsForFetchMatchSummaryQuery(region, summonerName, queryParams = {}) {
  const fullParams = {
    regionId: region,
    summonerName: replacePlusFromURLPath(summonerName.toLowerCase()),
    queueType: queryParams.queueType || [],
    duoName: queryParams.duoName || "",
    role: queryParams.role || [],
    seasonIds: !!queryParams.season ? [parseInt(queryParams.season)] : [INTERNAL_CURRENT_SEASON, INTERNAL_CURRENT_SEASON - 1],
    championId: isNaN(parseInt(queryParams.championId)) ? [] : [parseInt(queryParams.championId)],
  };

  return fullParams;
}

export function useFetchSummonerMatchSummaries(regionId, summonerName, queryParams, clientParams = {}) {
  const params = getParamsForFetchMatchSummaryQuery(regionId, summonerName, queryParams);

  return useQuery(FETCH_MATCH_SUMMARIES, {
    variables: params,
    ...clientParams,
  });
}

export function useFetchSummonerMatchSummariesLazily(regionId, summonerName, queryParams, clientParams = {}) {
  const client = useApolloClient();
  const params = getParamsForFetchMatchSummaryQuery(regionId, summonerName, queryParams);

  const [fetchState, setFetchState] = useState({ loading: false, data: null, error: null });

  const getSummonerMatchSummaries = (page) => {
    setFetchState({ loading: true, data: null, error: null });
    client
      .query({
        query: FETCH_MATCH_SUMMARIES,
        variables: { ...params, page: page },
        ...clientParams,
      })
      .then((response) => {
        setFetchState({ loading: false, data: response.data.fetchPlayerMatchSummaries, error: null });
      })
      .catch((error) => {
        setFetchState({ loading: false, data: null, error: error });
      });
  };

  return [getSummonerMatchSummaries, fetchState];
}
